module.exports = __webpack_public_path__ + "static/media/UnionPay.95c8464c.svg";